export default "__VITE_ASSET__BAhu1vuu__"